import { render, staticRenderFns } from "./healthTreatForm.vue?vue&type=template&id=4582b510&scoped=true&"
import script from "./healthTreatForm.vue?vue&type=script&lang=js&"
export * from "./healthTreatForm.vue?vue&type=script&lang=js&"
import style0 from "./healthTreatForm.vue?vue&type=style&index=0&id=4582b510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4582b510",
  null
  
)

export default component.exports